// extracted by mini-css-extract-plugin
var _1 = "Comment-module__animateUploadProgressBarWidth--EiP9P";
var _2 = "Comment-module__animatedBackground--rZsY4";
var _3 = "Comment-module__comment--KEQRz";
var _4 = "Comment-module__commentActions--oyYTr";
var _5 = "Comment-module__commentAuthor--TnHBy";
var _6 = "Comment-module__commentButton--U_iUf";
var _7 = "Comment-module__commentContent--qMUFO";
var _8 = "Comment-module__commentLeft--x0G9i";
var _9 = "Comment-module__commentMeta--at66F";
var _a = "4px";
var _b = "Comment-module__commentReactions--nLyAs";
var _c = "Comment-module__commentRight--ffWFX";
var _d = "Comment-module__commentRightSheet--hX_jH";
var _e = "Comment-module__editing--Obr9W";
var _f = "Comment-module__editingActions--hdkA4";
var _10 = "Comment-module__first--J8ywp";
var _11 = "Comment-module__hasExtraBottomPadding--wCjnK";
var _12 = "Comment-module__last--hpU_m";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "comment", _4 as "commentActions", _5 as "commentAuthor", _6 as "commentButton", _7 as "commentContent", _8 as "commentLeft", _9 as "commentMeta", _a as "commentMetaMarginBottom", _b as "commentReactions", _c as "commentRight", _d as "commentRightSheet", _e as "editing", _f as "editingActions", _10 as "first", _11 as "hasExtraBottomPadding", _12 as "last" }
